"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 25 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M2.187 10.13C4.336 7.021 8.116 5.4 12 5.4c3.884 0 7.664 1.621 9.813 4.729a1.203 1.203 0 0 0 1.248.514 1.2 1.2 0 0 0 .726-1.878C21.1 4.877 16.498 3 12 3 7.503 3 2.901 4.877.213 8.764a1.2 1.2 0 1 0 1.974 1.366ZM12.46 20.909a1.2 1.2 0 1 1-.92-2.219 1.2 1.2 0 0 1 .92 2.219Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.838 13.36c3-3.682 9.324-3.682 12.324 0v.001a1.2 1.2 0 0 0 1.86-1.516c-3.96-4.861-12.084-4.861-16.044 0a1.2 1.2 0 1 0 1.86 1.515Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 15.836a4.325 4.325 0 0 1 3.035 1.223 1.199 1.199 0 0 0 .847.344h.017a1.2 1.2 0 0 0 .83-2.056 6.72 6.72 0 0 0-4.73-1.91 6.722 6.722 0 0 0-4.729 1.91 1.2 1.2 0 0 0 .832 2.056h.016a1.2 1.2 0 0 0 .847-.344A4.325 4.325 0 0 1 12 15.836Z"
  })]
});